// src/http.js
import axios from "axios";
import endpoints from "./api.router.config";
import { useNavigate } from "react-router-dom";

/* ========= Helpers ========= */
// Récupère l'id utilisateur encodé depuis le cookie user_info (posé par le back)
function readUserIdFromCookie() {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(/(?:^|;\s*)user_info=([^;]+)/);
  if (!m) return null;
  try {
    const obj = JSON.parse(decodeURIComponent(m[1]));
    return obj?.id ? String(obj.id) : null; // id déjà encodé (base64url)
  } catch {
    return null;
  }
}

/* ========= Axios instance ========= */
// endpoints.baseUrl attendu: https://logistic.tydal-dev.cloud/api/v1
export const http = axios.create({
  baseURL: endpoints.baseUrl,
  withCredentials: true, // envoie les cookies httpOnly
  timeout: 20000,
});

/* ========= Request interceptor =========
   (pas de token côté front → rien à injecter)
*/
http.interceptors.request.use(
  (config) => config,
  (err) => Promise.reject(err),
);

/* ========= Response interceptor (401 -> refresh avec user-id) ========= */
let isRefreshing = false;
let queue = [];

function resolveQueue() {
  queue.forEach((cb) => {
    try {
      cb();
    } catch {}
  });
  queue = [];
}

http.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;

    console.log(error);

    console.warn("[HTTP INTERCEPTOR]", {
      url: original?.url,
      status,
      body: error?.response?.data,
      isRefreshing,
    });

    // Si ce n'est pas une 401 ou que cette requête a déjà été retentée → propage l'erreur
    if (!original || original._retry || status !== 401) {
      return Promise.reject(error);
    }

    // Si un refresh est déjà en cours → attendre puis relancer la requête initiale
    if (isRefreshing) {
      await new Promise((resolve) => queue.push(resolve));
      original._retry = true;
      return http(original);
    }

    // Démarre le refresh
    try {
      isRefreshing = true;

      const userId = readUserIdFromCookie(); // depuis user_info (id encodé)
      await axios.post(
        endpoints.auth.refresh,
        {},
        {
          withCredentials: true,
          timeout: 15000,
          headers: userId ? { "user-id": userId } : {},
        },
      );

      // Refresh OK → relancer la requête initiale
      resolveQueue();
      original._retry = true;
      return http(original);
    } catch (e) {
      // Refresh KO → log + redirection SSO (qui te ramènera sur /home après login)
      console.warn("[REFRESH FAILED]", {
        status: e?.response?.status,
        data: e?.response?.data,
      });
      try {
        if (typeof window !== "undefined") {
          window.location.href = endpoints.auth.login;
        }
      } catch {}
      return Promise.reject(e);
    } finally {
      isRefreshing = false;
    }
  },
);
